import apiordemservicoweb from '@/services/api-recebimentoweb';

let findTimeout = null;

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }, { data: { count: total } }] = await Promise.all([
        apiordemservicoweb.get('ordemservico/all', { params: { ...where, ...params } }),
        apiordemservicoweb.get('ordemservico/count', { params: where }),
      ]);

      return { data, total };
    },

    // CONSULTA COM CONTROLE DE CACHE
    async findWithCache({ commit, state }, { force, ttl } = {}) {
      if (!force && state.list?.length > 0) {
        return;
      }

      clearTimeout(findTimeout);

      const { data } = await apiordemservicoweb.get('ordemservico');

      commit('SET_LIST', data);

      if (ttl === Infinity) return;

      findTimeout = setTimeout(() => {
        commit('SET_LIST', null);
      }, ttl ?? 1000 * 60); // TTL -> Time To Live
    },

    // CONSULTA SEM CACHE
    async findByIdWeb(_, { id }) {
      const { data } = await apiordemservicoweb.get(`ordemservico/${id}`);
      return data;
    },

    async findById(_, { id }) {
      const { data } = await apiordemservicoweb.get(`ordemservico/id/${id}`);
      return data;
    },

    async findByCodigo(_, { id }) {
      const { data } = await apiordemservicoweb.get(`ordemservico/codigo/${id}`);
      return data;
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
  },
};
